import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";

import { ALLOWED_MODULES } from "../../constants/enums";
import path from "path";

const TotalBookingList = Loadable(
  lazy(() =>
    import("./totalbooking").then(({ TotalBookingList }) => ({
      default: TotalBookingList,
    }))
  )
);

export const totalBookingRoutes = [
  {
    path: "/total-bookings",
    exact: true,
    element: (
      <AuthorizedRoute moduleIds={[ALLOWED_MODULES.BOOKING]}>
        <TotalBookingList />
      </AuthorizedRoute>
    ),
  },
  // {
  // 	path: "/customer-overview/:id",
  // 	exact: true,
  // 	element: (
  // 		<AuthorizedRoute

  // 			moduleIds={[ALLOWED_MODULES.CUSTOMER]}
  // 		>
  // 			<CustomerOverview />
  // 		</AuthorizedRoute>
  // 	),
  // },
  // {
  // 	path: "/edit-customer/:id",
  // 	exact: true,
  // 	element: (
  // 		<AuthorizedRoute

  // 			moduleIds={[ALLOWED_MODULES.CUSTOMER]}
  // 		>
  // 			<EditCustomer />
  // 		</AuthorizedRoute>
  // 	),
  // },
];
